// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { buildBody } from './queryHelper'

// Messages api
// we generate markup for messages in wordpress and this return the markup to be displayed
export const messagesApi = createApi({
  reducerPath: 'messagesApi',
  baseQuery: fetchBaseQuery({ baseUrl: urls.ajax }),
  endpoints: (builder) => ({

    noOpenSeats: builder.query({
        query () {
            return {
                url: urls.ajax,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: 'POST',
                body: buildBody({
                    action: 'getMessageMarkup',
                    title: 'No Open Seats',
                    message: 'There are no future courses with open seats available at this time. Here is the shortest waitlist.',
                    type: 'warning'
                })
            }
        
        }
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useNoOpenSeatsQuery} = messagesApi